/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/baglass/js/baglass/app/NavbarButtonSlideoutController',
	'jquery'
], function(BaseClass, $) {


	/**
	 * @return true if passed slideout is defined and isOpen
	 */
	var _isSlideoutOpen = function(slideout) {
		return slideout && slideout.isOpen();
	};

	var _closeSlideout = function() {
		this._slideout.hide({
			force: true
		});
		delete this._slideout;
	};

	var ActionHandler = BaseClass.extend({

		isAppviewScope: true,
		//common options shared by children action handlers
		commonOptions: {
			enableTabLooping: false
		},

		getCustomSpec: function(context) {
			return {
				'options': $.extend({}, this.commonOptions, this.getExtraCustomSpec(context))
			};
		},

		//SubClass to implement
		getExtraCustomSpec: function(/*context*/) {
			return {};
		},

		onShowCallback: function(context, slideout) {
			this._slideout = slideout;
			this._slideout.$el.addClass('dashboardPane');
			var resize = () => {
				try {
					$(window).resize();
				} catch (e) {
					console.error(e);
				}
			};

			this._slideout.on('done:show', resize);
			this._slideout.on('hide', resize);

			context.target.plugin.actionController = this;
		},

		onHideCallback: function() {
			if (_isSlideoutOpen(this._slideout) === true) {
				_closeSlideout.call(this);
			}
		},

		/**
		 * Closes the slideout; Defined to be invoked by the button controller
		 */
		onHide: function() {
			if (_isSlideoutOpen.call(this, this._slideout) === true) {
				_closeSlideout.call(this);
			}
		},

		/**
		 * Creates the slideout to be open
		 * @virtual
		 * @return the created slideout
		 */
		_createSlideout: function(/*context*/) {
			// To be implemented by concrete class
		}

	});
	return ActionHandler;
});
